import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-services-page',
  standalone: true,
  imports: [RouterLink],
  template: `
  <main class="page">
    <div class="container">
      <header class="page__head">
        <h1 class="h1">Services</h1>
        <p class="lead">Des offres orientées impact : de la collecte à la visualisation, jusqu’à l’IA utile et mesurable.</p>
      </header>

      <div class="grid">
        <section class="card">
          <h2 class="h2">Data Analytics</h2>
          <ul class="list">
            <li>KPI & reporting exécutif</li>
            <li>Analyse exploratoire & segmentation</li>
            <li>Data storytelling & adoption</li>
          </ul>
        </section>

        <section class="card">
          <h2 class="h2">BI & Data Viz</h2>
          <ul class="list">
            <li>Power BI, Qlik, Tableau</li>
            <li>Dashboards décisionnels & gouvernance KPI</li>
            <li>Modélisation (star schema) & performance</li>
          </ul>
        </section>

        <section class="card">
          <h2 class="h2">Data Engineering</h2>
          <ul class="list">
            <li>Pipelines ETL/ELT fiables</li>
            <li>Data Warehouse / Lakehouse</li>
            <li>Qualité, monitoring & sécurité</li>
          </ul>
        </section>

        <section class="card">
          <h2 class="h2">Data Science & IA</h2>
          <ul class="list">
            <li>Forecasting & scoring</li>
            <li>Détection d’anomalies</li>
            <li>Automatisation orientée ROI</li>
          </ul>
        </section>
      </div>

      <div class="cta">
        <a class="btn primary" routerLink="/contact">Demander un audit</a>
        <a class="btn ghost" routerLink="/">Retour accueil</a>
      </div>
    </div>
  </main>
  `,
  styles: [`
    .page{ padding: 44px 0 70px; }
    .page__head{ max-width: 860px; }
    .lead{ color: var(--muted); font-weight: 750; }
    .grid{
      margin-top: 18px;
      display:grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 14px;
    }
    .card{
      border-radius: var(--radius-xl);
      border: 1px solid rgba(255,255,255,.10);
      background: rgba(255,255,255,.04);
      padding: 18px;
      box-shadow: 0 24px 80px rgba(0,0,0,.35);
    }
    .list{ margin: 10px 0 0; padding-left: 18px; color: var(--muted); font-weight: 700; }
    .list li{ margin: 8px 0; }
    .cta{ margin-top: 18px; display:flex; gap: 12px; flex-wrap:wrap; }
    @media (max-width: 860px){ .grid{ grid-template-columns: 1fr; } }
  `]
})
export class ServicesPageComponent {}
